module.exports = __webpack_public_path__ + "static/media/green_stacker.c729d31a.png";